export default {
      id: "video-event_driver-distraction-usage",
      viewBox: "0 0 21.398 25.844",
      url: __webpack_public_path__ + "img/icons.svg#video-event_driver-distraction",
      toString: function () {
        return this.url;
      }
    }